import * as type from './bannerActionTypes';

export const getBannersActiveAction = () => ({
  type: type.GET_BANNERS_ACTIVE,
});

export const setBannersActiveAction = (banners) => ({
  type: type.SET_BANNERS_ACTIVE,
  banners,
});
